
import moment from 'moment'

export default class Model {
  constructor (id) {
    this.id = id ?? null
  }

  _parseUtcToLocalMoment (v) {
    return moment
      .utc(v, 'YYYY-MM-DD HH:mm:ss', true) // strict mode ON
      .local()
  }

  _nowToUtcString () {
    return moment()
      .utc()
      .format('YYYY-MM-DD HH:mm:ss')
  }

  $log (model, action) {
    $vm.$store.dispatch('log', {
      model,
      model_id: this.id,
      action,
    })
  }
}
